import { CircularProgress } from "@mui/material";
import "./bgloader.scss";

const BgLoader = () => {
  return (
    <div className="bgloader_route">
      <CircularProgress size="30px" />
    </div>
  );
};

export default BgLoader;
